import { MediaGalleryData } from '@components/PropertyDetailsComponents/MediaGallery/mapData';

export const shareHeaderLoadingData = {
  cost: '0',
  address: null,
  url: '#',
  isFavorite: false,
  favId: '',
  onSaveProperty: null,
  listingId: '',
  currencyCode: '',
  advisorDetails: {
    name: null,
    originatingSystemName: null,
    office: null,
    img: '/assets/user_icon.png',
    listingId: null,
    title: 'Real Estate Advisor',
  },
};

export const developmentHeaderLoadingData = {
  header: 'Loading...',
  subheader: '-',
};

export const listingSnapshotLoadingData = {
  listUrl: null,
  propertyType: 'Loading...',
  bathrooms: '0',
  bedrooms: '0',
  squareFeet: 0,
  listOfficeName: 'N/A',
  listingId: null,
  listAgentFullName: null,
  includeBrokeragePhone: true,
  brokeragePhone: null,
  country: null,
};

export const listingHighlightsLoadingData = [
  {
    type: 'standard',
    header: 'Property',
    tabListings: [
      { header: 'View', content: '', img: '' },
      { header: 'Association', content: '', img: '' },
      { header: 'Carport', content: '', img: '' },
      { header: 'County', content: '', img: '' },
      { header: 'Stories', content: '', img: '' },
      { header: 'Heating', content: '', img: '' },
      { header: 'Cooling', content: '', img: '' },
      { header: 'Tax Annual Amount', content: '', img: '' },
      { header: 'Attached Garage Y/N', content: '', img: '' },
      { header: 'Lot Size Acres', content: '', img: '' },
      { header: 'Lot Size (Sq Ft)', content: '', img: '' },
      { header: 'Living Area (Sq Ft)', content: '', img: '' },
      { header: 'Subdivision', content: '', img: '' },
    ],
  },
];

export const drawerLoadingData = [
  {
    header: 'Interior Features',
    description: '..loading',
  },
  {
    header: 'Exterior Features',
    description: '..loading',
  },
  {
    header: 'Utilities',
    description: '..loading',
  },
];

export const featuresAmenitiesLoadingData = ['...loading'];

export const locationLoadingData = {
  state: 'Loading...',
  city: null,
  zip: null,
  neighborhood: null,
  address: null,
  center: {
    lat: null,
    lng: null,
  },
  mappedResults: null,
};
